import {
  FORM_FIELDS_CONFIG,
  type DATABASE_FIELDS,
} from '~/components/features/FormSubmission/formSubmissionUtils'
import { SETTINGS } from '~/utils/settings'

const API_ENDPOINT = `${SETTINGS.general.apiFile}`

export const validateForm = (formData: DATABASE_FIELDS) => {
  let errors: { [key: string]: string } = {}
  let isValid = true

  const keepOnlyTheseFields = SETTINGS.results
    .formFieldsToDisplayWithSorting as string[]

  FORM_FIELDS_CONFIG.forEach(
    ({ name, validate, isMandatory, errorMessage }) => {
      if (keepOnlyTheseFields.includes(name)) {
        const value = formData[name]
        if (!!isMandatory && value !== undefined && !validate(value)) {
          isValid = false
          errors[name] = errorMessage
        }
      }
    },
  )

  return { isValid, errors }
}

export const submitQuizForm = async (
  formData: DATABASE_FIELDS,
): Promise<string> => {
  const endpoint = `https://${window.location.hostname}/api/${API_ENDPOINT}`

  console.log('Submitting form data:', formData)

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(formData).toString(),
    })

    console.log('Response status:', response.status)

    // Log the raw response text for debugging
    const responseText = await response.text()
    console.log('Response text:', responseText)

    // Try to parse the response as JSON
    let data
    try {
      // Check if the response contains HTML (error messages from PHP)
      if (responseText.includes('<br />') || responseText.includes('<b>')) {
        // Extract JSON if it exists at the end of the response
        const jsonMatch = responseText.match(/\{.*\}/)
        if (jsonMatch) {
          data = JSON.parse(jsonMatch[0])
        } else {
          throw new Error('Response contains HTML errors')
        }
      } else {
        data = JSON.parse(responseText)
      }
    } catch (e) {
      console.error('Failed to parse response as JSON:', e)
      throw new Error("La réponse du serveur n'est pas au format JSON valide")
    }

    if (!response.ok) {
      throw new Error(data.message || 'La soumission a échoué')
    }

    return `${data.message}, vous allez etre redirigé... `
  } catch (error) {
    console.error('Erreur lors de la soumission:', error)
    throw new Error('❌ Une erreur est survenue, veuillez réessayer.')
  }
}
